/* A small centred dialog, following the scrim/panel shape LeadDrawer already
   established rather than inventing a second modal idiom.

   Escape closes and the scrim closes, because a dialog you can only leave by
   finding the right button is the kind of thing that traps someone on a phone. */
import { useEffect, type ReactNode } from 'react';
import { Icon } from '@/lib/icons';

export function Modal({ title, onClose, children }: { title: string; onClose: () => void; children: ReactNode }) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="es-modal" role="dialog" aria-modal="true" aria-label={title}>
      <div className="es-modal__scrim" onClick={onClose} />
      <div className="es-modal__panel">
        <div className="es-modal__top">
          <strong>{title}</strong>
          <button type="button" className="es-modal__x" onClick={onClose} aria-label="Close">
            <Icon name="x" size={15} />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}
